import { Badge, Tooltip, TooltipContent, TooltipTrigger } from "@aircall/ds";

type KeysListProps = {
  keys: (string | null)[];
};

// A key topic longer than this is truncated with an ellipsis and its full text
// is revealed in a tooltip. Shorter topics render in full (matching the
// pre-migration pill behaviour). The DS Badge clips at max-w-36 by default, so
// we lift that cap and control the length ourselves for a deterministic result.
export const KEY_TOPIC_MAX_LENGTH = 28;

function KeyTopicBadge({ label }: { label: string }) {
  const isTruncated = label.length > KEY_TOPIC_MAX_LENGTH;

  if (!isTruncated) {
    return (
      <Badge color="charcoal" tone="light" className="max-w-none">
        {label}
      </Badge>
    );
  }

  const truncated = `${label.slice(0, KEY_TOPIC_MAX_LENGTH).trimEnd()}…`;

  return (
    <Tooltip>
      <TooltipTrigger render={<Badge color="charcoal" tone="light" />}>
        {truncated}
      </TooltipTrigger>
      <TooltipContent side="top" align="center">
        {label}
      </TooltipContent>
    </Tooltip>
  );
}

export function KeysList({ keys }: KeysListProps) {
  return (
    <div
      className="flex flex-wrap items-start gap-2"
      data-test="call-context-key-topics-list"
    >
      {keys.map((key) =>
        key === null ? null : <KeyTopicBadge key={key} label={key} />
      )}
    </div>
  );
}
